interface IInfoArea {
    title: string,
    value: string
}

const InfoArea = ({ title, value }: IInfoArea) => {
    return (
        <div className='flex items-center'>
            <p className='w-[170px] text-lg shrink-0'>{title}</p>
            <div className='bg-[#F8F8FA] px-6 py-3 rounded min-w-[600px] min-h-12'>
                {value && value}
            </div>
        </div>
    )
}

export default InfoArea